import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Solo.css';
import redIcon from '../../static/image/红.png';
import yellowIcon from '../../static/image/黄.png';
import blueIcon from '../../static/image/蓝.png';
import QuizSettingsModal from '../../components/QuizSettingsModal/QuizSettingsModal';

const Solo = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedQuizType, setSelectedQuizType] = useState(null);
  const [showComingSoonDialog, setShowComingSoonDialog] = useState(false);

  // 组件加载时检查是否需要恢复弹窗状态
  useEffect(() => {
    const quizSettingsState = localStorage.getItem('quizSettingsState');
    if (quizSettingsState) {
      try {
        const state = JSON.parse(quizSettingsState);
        setSelectedQuizType(state.quizType);
        setShowModal(true);
        // 清除状态，避免下次再打开
        localStorage.removeItem('quizSettingsState');
      } catch (error) {
        console.error('恢复Quiz设置状态失败:', error);
      }
    }
  }, []);

  const handleColorSelect = (color) => {
    
    // 显示"即将上线，敬请期待"弹窗
    // setShowComingSoonDialog(true);
    
    // 以下代码暂时注释掉，等功能上线后再启用
    setSelectedQuizType(color);
    setShowModal(true);
  };

  return (
    <div className="solo-container">
      <div className="color-selection-container">
        <div className="color-card" onClick={() => handleColorSelect('蓝')}>
          <img
            src={blueIcon}
            alt="蓝色"
            className="color-icon color-icon-blue"
          />
          <div className="color-text color-text-blue">题量赛</div>
        </div>
        <div className="color-card" onClick={() => handleColorSelect('黄')}>
          <img
            src={yellowIcon}
            alt="黄色"
            className="color-icon color-icon-yellow"
          />
          <div className="color-text color-text-yellow">计时赛</div>
        </div>
        <div className="color-card" onClick={() => handleColorSelect('红')}>
          <img
            src={redIcon}
            alt="红色"
            className="color-icon color-icon-red"
          />
          <div className="color-text color-text-red">抢答赛</div>
        </div>
      </div>

      {/* 设置弹窗 */}
      <QuizSettingsModal 
        visible={showModal}
        onClose={() => setShowModal(false)}
        quizType={selectedQuizType}
      />

      {/* 即将上线弹窗 */}
      {showComingSoonDialog && (
        <div className="coming-soon-overlay" onClick={() => setShowComingSoonDialog(false)}>
          <div className="coming-soon-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="coming-soon-icon">🚀</div>
            <h2 className="coming-soon-title">即将上线</h2>
            <p className="coming-soon-text">敬请期待</p>
            <button 
              className="coming-soon-button"
              onClick={() => setShowComingSoonDialog(false)}
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Solo;

